import React, { useState, useEffect } from 'react';
import API from '../../constants/config';

const AgentBikesModal = ({ agent, onClose }) => {
    const [bikes, setBikes] = useState([]);
    const [colors, setColors] = useState([]); // Colors state
    const [showAddForm, setShowAddForm] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        engine_number: '', 
        registration_number: '', 
        chassis_number: '', 
        model_name: '', 
        model_year: '', 
        color: '', // Missing part fixed
        demand_price: ''
    });

    useEffect(() => { 
        fetchBikes();
        fetchColors(); // Component load hote hi colors fetch honge
    }, [agent.id]);

    const fetchBikes = async () => {
        try {
            const res = await API.get(`/v1/agent-bikes/agent/${agent.id}`);
            setBikes(res.data.data || []);
        } catch (err) { console.error("Error fetching bikes", err); }
    };

    // Aapki Colors API call
    const fetchColors = async () => {
        try {
            const res = await API.get('/v1/colors'); // Adjust path as per your API
            setColors(res.data.data || []);
        } catch (err) { console.error("Error fetching colors", err); }
    };

    const handleAddBike = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await API.post('/v1/agent-bikes', { ...formData, agent_id: agent.id });
            if (res.data.success) {
                setFormData({ 
                    engine_number: '', registration_number: '', chassis_number: '', 
                    model_name: '', model_year: '', color: '', demand_price: '' 
                });
                setShowAddForm(false);
                fetchBikes();
            }
        } catch (err) { alert("Error adding bike"); }
        finally { setLoading(false); }
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.modalHeader}>
                    <h3>🏍️ {agent.full_name}'s Inventory</h3>
                    <button onClick={onClose} style={styles.closeBtn}>&times;</button>
                </div>

                {!showAddForm ? (
                    <>
                        <button onClick={() => setShowAddForm(true)} style={styles.addBtn}>+ ADD NEW BIKE</button>
                        <table style={styles.table}>
                            <thead style={styles.thead}>
                                <tr>
                                    <th>REG # / ENGINE</th>
                                    <th>MODEL / COLOR</th>
                                    <th>DEMAND</th>
                                    <th>STATUS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bikes.map(bike => (
                                    <tr key={bike.id} style={styles.tr}>
                                        <td>
                                            <b style={{color:'#2563eb'}}>{bike.registration_number || 'N/A'}</b><br/>
                                            <small>{bike.engine_number}</small>
                                        </td>
                                        <td>
                                            {bike.model_name} ({bike.model_year})<br/>
                                            <small style={{color:'#64748b'}}>Color: {bike.color}</small>
                                        </td>
                                        <td><b>Rs. {parseInt(bike.demand_price).toLocaleString()}</b></td>
                                        <td>
                                            <span style={{...styles.status, background: bike.status === 'sold' ? '#fee2e2' : '#dcfce7'}}>
                                                {bike.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                ) : (
                    <form onSubmit={handleAddBike} style={styles.grid}>
                        <input required style={styles.input} placeholder="Reg Number (RIM-24-550)" value={formData.registration_number} onChange={e => setFormData({...formData, registration_number: e.target.value})} />
                        <input required style={styles.input} placeholder="Engine Number" value={formData.engine_number} onChange={e => setFormData({...formData, engine_number: e.target.value})} />
                        <input required style={styles.input} placeholder="Chassis Number" value={formData.chassis_number} onChange={e => setFormData({...formData, chassis_number: e.target.value})} />
                        <input required style={styles.input} placeholder="Model Name (CD-70)" value={formData.model_name} onChange={e => setFormData({...formData, model_name: e.target.value})} />
                        <input required type="number" style={styles.input} placeholder="Year" value={formData.model_year} onChange={e => setFormData({...formData, model_year: e.target.value})} />
                        
                        {/* COLOR DROPDOWN FROM API */}
                        <select 
                            required 
                            style={styles.input} 
                            value={formData.color} 
                            onChange={e => setFormData({...formData, color: e.target.value})}
                        >
                            <option value="">Select Color</option>
                            {colors.map(c => (
                                <option key={c.id} value={c.name}>{c.name}</option>
                            ))}
                        </select>

                        <input required type="number" style={{...styles.input, gridColumn: '1/-1'}} placeholder="Agent Demand Price" value={formData.demand_price} onChange={e => setFormData({...formData, demand_price: e.target.value})} />
                        
                        <div style={{gridColumn:'1/-1', display:'flex', gap:'10px', marginTop:'10px'}}>
                            <button type="submit" disabled={loading} style={styles.saveBtn}>SAVE TO INVENTORY</button>
                            <button type="button" onClick={() => setShowAddForm(false)} style={styles.cancelBtn}>CANCEL</button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

const styles = {
    overlay: { position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 11000 },
    modal: { background: '#fff', width: '750px', borderRadius: '15px', padding: '25px', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' },
    modalHeader: { display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '20px' },
    closeBtn: { background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#64748b' },
    addBtn: { background: '#1e293b', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', marginBottom: '20px', cursor: 'pointer', fontWeight: 'bold' },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: '14px' },
    thead: { background: '#f8fafc', textAlign: 'left', color: '#64748b' },
    tr: { borderBottom: '1px solid #f1f5f9' },
    input: { padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px' },
    grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' },
    saveBtn: { flex: 2, background: '#10b981', color: '#fff', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' },
    cancelBtn: { flex: 1, background: '#e2e8f0', color: '#475569', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer' },
    status: { padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold', textTransform: 'uppercase' }
};

export default AgentBikesModal;